import LANGUAGES from './languages';

export const DEFAULT_LANGUAGE = 'fr';

export const SUPPORTED_LANGUAGE_IDS = LANGUAGES.map((language) => language.id);

const SUPPORTED_LANGUAGE_SET = new Set(SUPPORTED_LANGUAGE_IDS);

export const normalizeSupportedLanguage = (
	input: string | null | undefined,
	fallback = DEFAULT_LANGUAGE
): string => {
	if (typeof input !== 'string') {
		return fallback;
	}

	const trimmed = input.trim().toLowerCase();

	if (!trimmed) {
		return fallback;
	}

	const firstToken = trimmed.split(/[ \-_/]/)[0];
	const candidate = firstToken.slice(0, 2);

	if (!candidate || !SUPPORTED_LANGUAGE_SET.has(candidate)) {
		return fallback;
	}

	return candidate;
};
